import FeaturedCitiesInfo from 'ha/constants/FeaturedCities';
import { City, Suggestion } from '../types';

export const getFilteredCities = (cities: City[]) => {
  return cities
    .filter(item => {
      const { [item.city]: { isHidden = false } = {} } = FeaturedCitiesInfo;

      return !isHidden;
    })
    .map(({ cityLocalized, countryLocalized, searchUrl }) => ({
      cityLocalized,
      countryLocalized,
      searchUrl,
    }));
};

export const getFilteredApartments = (
  cities: City[],
  localizedApartmentSlug: string,
): Suggestion[] => {
  return cities
    .filter(item => {
      const {
        [item.city]: { hasAppartmentLink = false } = {},
      } = FeaturedCitiesInfo;

      return hasAppartmentLink;
    })
    .map(({ cityLocalized, countryLocalized, searchUrl }) => ({
      cityLocalized,
      countryLocalized,
      searchUrl: `${searchUrl}/${localizedApartmentSlug}`,
    }));
};

export const getFilteredPrivateRooms = (
  cities: City[],
  localizedPrivateRoomSlug: string,
): Suggestion[] => {
  return cities
    .filter(item => {
      const { [item.city]: { hasRoomLink = false } = {} } = FeaturedCitiesInfo;

      return hasRoomLink;
    })
    .map(({ cityLocalized, countryLocalized, searchUrl }) => ({
      cityLocalized,
      countryLocalized,
      searchUrl: `${searchUrl}/${localizedPrivateRoomSlug}`,
    }));
};
